<template>
  <div class="template-table">
    <div class="topbar-bottom">
      <div class="select">
        <el-select v-model="selectedQuestionnaireType" filterable placeholder="请选择模版分类"
          @change="questionnaireTypeChange" clearable style="width: 200px;">
          <el-option v-for="item in questionnaireTypeList" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="template-list">
      <el-table :data="templateTypeList" style="width: 100%; overflow: auto;">
        <el-table-column prop="formName" label="名称" width="400">
        </el-table-column>
        <el-table-column label="模板分类">
          <template slot-scope="scope">
            {{ questionnaireTypeList[scope.row.templateType - 1].dictLabel }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createBy" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <div class="operate">
              <!-- 详情 -->
              <el-button type="success" size="small" @click="detailClick(scope.row)">详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :pageSize="pageSize" :total="total" @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"></pagination>
    <templateDetailDialog v-show="templateDetailDialogShow" :questionTypeList="questionTypeList"
      :surveyTableDetail="surveyTableDetail" :templateDetailDialogShow.sync="templateDetailDialogShow" />
  </div>
</template>

<script>
import templateDetailDialog from "../template-detail-dialog/templateDetailDialog.vue";
export default {
  props: ["templateTypeList", "questionTypeList", "total", "questionnaireTypeList"],
  components: {
    templateDetailDialog
  },
  data() {
    return {
      pageSize: 10,
      // surveyTableData: null,
      // statisticalResultDialogVisible: false,
      surveyTableDetail: {},
      templateDetailDialogShow: false,
      selectedQuestionnaireType: '',
    };
  },
  methods: {
    questionnaireTypeChange(e) {
      // console.log(e);
      this.$emit("questionnaireTypeChange", e);
    },
    currentPageNumChange(e) {
      this.$emit("currentTemplateTable", e);
    },
    handleSizeChange(pageSize) {
      this.$emit("currentTemplateTablePageSize", pageSize);
    },
    detailClick(data) {
      this.get(
        this.$url.selectQuestionnaireFormDetail + "/" + data.id
      ).then((res) => {
        // console.log("获取调查表模版详情==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        const data = res.data[0];

        this.surveyTableDetail = {
          ...data,
          surveyQuestionsList: data.surveyQuestionsList.map((item, index) => ({
            ...item,
            isRequiredStatus: item.isRequired == '1', // 转布尔
            sequence: index + 1                        // 添加序号
          }))
        };
        this.templateDetailDialogShow = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./templateTable.scss";
</style>